import { pendingBookingConstants } from '../utils/types';

export function setPendingBookingSessionEventId(sessionEventId) {
  return {
    type: pendingBookingConstants.SET_PENDING_SESSION_EVENT_ID,
    payload: {
      sessionEventId
    }
  };
}

export function setPendingBookingCourtEventId(courtEventId) {
  return {
    type: pendingBookingConstants.SET_PENDING_COURT_EVENT_ID,
    payload: {
      courtEventId
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/pendingBookingActions.js